export default {
  data() {
    return {
      kriterias: [],
      kriteria: null
    };
  },
  methods: {
    async getCriteriasByCategory() {
      this.kriterias = await this.$store.dispatch("getCriteriasByCategory", {
        year: this.year,
        category: this.category
      });
      this.kriteria =
        this.kriterias.length > 0 ? this.kriterias[0].nomor : null;
    },
    async getCriteriasByJurusanAndProdi() {
      this.kriterias = await this.$store.dispatch(
        "getCriteriasByJurusanAndProdi",
        {
          year: this.year,
          category: this.category,
          jurusan: this.jurusan,
          prodi: this.prodi
        }
      );
      this.kriteria =
        this.kriterias.length > 0 ? this.kriterias[0].nomor : null;
    }
  }
};
